import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=cbf93a80"
import script from "./OverviewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports